import { AuthRestrictionMode } from './auth-restriction.i';
var AuthRestrictionBuilder = /** @class */ (function () {
    function AuthRestrictionBuilder() {
        this.hcAuthRestriction = {
            mode: AuthRestrictionMode.NONE,
            allowedDomains: []
        };
    }
    AuthRestrictionBuilder.prototype.withPermissionMode = function (mode) {
        this.hcAuthRestriction.mode = mode;
        return this;
    };
    AuthRestrictionBuilder.prototype.withAllowedDomains = function (domains) {
        this.hcAuthRestriction.allowedDomains = domains;
        return this;
    };
    AuthRestrictionBuilder.prototype.build = function () {
        return this.hcAuthRestriction;
    };
    return AuthRestrictionBuilder;
}());
export { AuthRestrictionBuilder };
//# sourceMappingURL=auth-restriction.builder.js.map